import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { bookingInfo, initBooking } from './book.helper';
import { CleintService } from '../../../../shared/services/client.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnInit {


  constructor(

    private cleintService: CleintService,
    private message: NzMessageService,
    public datepipe: DatePipe
  ) { }
  AllData: any = [];
  AllCustomerData = [];
  displayTimeSection = false;
  formsCount = 4;
  isBtnDisabled = false;
  selectedTime;
  selectedDate;
  text_confirm = "تأكيد الحجز";
  siblings: Array<string>;
  account$: BehaviorSubject<bookingInfo> =
    new BehaviorSubject<bookingInfo>(initBooking);
  currentStep$: BehaviorSubject<number> = new BehaviorSubject(1);
  isCurrentFormValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private unsubscribe: Subscription[] = [];

  pushed_data = [];
  TimeLabel = [];

  selectedCourtsList = [];
  isLoading = false;

  ngOnInit(): void {

    this.TimeLabel = [];
    this.AllData = [];

  }


  updateAccount = (part: Partial<bookingInfo>, isFormValid: boolean) => {

    const currentAccount = this.account$.value;
    const updatedAccount = { ...currentAccount, ...part };
    this.account$.next(updatedAccount);
    this.isCurrentFormValid$.next(isFormValid);
    this.AllData = updatedAccount;
  }

  nextStep() {
    let nextStep = this.currentStep$.value + 1;
    if (nextStep > this.formsCount) {
      return;
    }

    // tslint:disable-next-line:triple-equals
    if (nextStep == 2) {
      nextStep = 3;
    }
    this.currentStep$.next(nextStep);




    // this.selectedTime = this.AllData.time.map(({ time }) => time);
    // this.selectedDate = this.AllData.time.map(({ date }) => date);
    this.getAvailableCourts();

    console.log(this.AllData);

  }
  nextStepConfirm() {
    this.isBtnDisabled = true;
    this.text_confirm = "الرجاء الانتظار..";
    this.selectedTime = this.AllData.time.map(({ time }) => time);
    this.selectedDate = this.AllData.time.map(({ date }) => date);
    console.log(this.selectedTime);
    console.log(this.selectedDate);
    const finalDate = [];
   
    for (let i = 0; i < this.selectedDate.length; i++) {
      let Setdate = this.datepipe.transform(this.selectedDate[i], 'yyyy-MM-dd');
      finalDate.push(Setdate);

    }
    console.log(finalDate);


    const params = {
      time: this.selectedTime,
      date: finalDate,
      court_id: this.AllData.court_id,
      customerName: this.AllData.customerName,
      customerPhone: this.AllData.customerPhone,
      customerEmail: this.AllData.customerEmail,
      payment_method: this.AllData.payment_method,
    };
    console.log(params);
    this.cleintService.NewAppointments(params).subscribe(
      (res: any) => {


        this.isBtnDisabled = false;


        if (res.data[0].payment_link) {
          window.location.href = res.data[0].payment_link;
          this.TimeLabel = [];
          this.AllData = []
        } else {
          this.currentStep$.next(5);
          console.log("wew");
          this.AllCustomerData = res?.data[0];
          console.log(this.AllCustomerData[0]);
          console.log("wew");
          this.TimeLabel = [];
          this.AllData = []

        }

        // this.message.success(res.message);


        //  / this.TimeLabel = [];
      },
      (err) => {
        this.isBtnDisabled = false;
        this.message.error(err.data.message);
      }
    );
  }

  prevStep() {
    let prevStep = this.currentStep$.value - 1;
    if (prevStep === 0) {
      return;
    }
    if (prevStep == 2) {
      prevStep = 1;
    }
    this.currentStep$.next(prevStep);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  async getAvailableCourts() {
    const Setdate = this.datepipe.transform(this.AllData.date, 'yyyy-MM-dd');
    this.selectedCourtsList = [];
    this.isLoading = true;
    this.cleintService.getAvailableCourts(Setdate, this.AllData.time[0].label).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.siblings = response?.data;
      },
      error: (error) => {
        this.isLoading = false;
      }
    }
    );


  }



  addHours(timeString) {
    let dt = new Date('1970-01-01T' + timeString);
    dt.setHours(dt.getHours() + 1);
    let TimeAddHour = dt.toLocaleTimeString([], { hour: "numeric", minute: "numeric", hour12: true });
    console.log(typeof TimeAddHour)

    return TimeAddHour;
  }


  tConvert(timeString) {
    const timeString12hr = new Date('1970-01-01T' + timeString)
      .toLocaleTimeString([],
        { hour: 'numeric', minute: 'numeric', hour12: true }
      );
    return timeString12hr
  }




}
